import React from "react";

import { FaInfoCircle, FaUsers } from "react-icons/fa";

import {
  MATCH_LABEL_STATES,
  buildCompactMatchTooltip,
  buildMatchLabelAriaLabel,
  formatCompactMatchLine,
  formatContextualMatchLine,
} from "../../utils/matchLabelContext";

import styles from "../../styles/components/product/MatchFusedScoreLine.module.css";



/**

 * Combined match % and cluster social proof in one line.

 */

const MatchFusedScoreLine = ({
  score,
  proof,
  className = "",
  as = "p",
  showIcon = true,
  labelContext = null,
  activeDecision = null,
  compact = false,
}) => {
  const line = compact
    ? formatCompactMatchLine(score, labelContext, proof)
    : formatContextualMatchLine(score, labelContext, proof);
  if (!line) return null;

  const variant = labelContext?.state || MATCH_LABEL_STATES.ALIGNED;
  const ariaLabel = buildMatchLabelAriaLabel(score, labelContext, activeDecision);
  const tooltip = compact
    ? buildCompactMatchTooltip(score, labelContext, proof, activeDecision)
    : labelContext?.tooltip || undefined;
  const showInfoIcon = compact
    ? Boolean(tooltip)
    : variant === MATCH_LABEL_STATES.RELATED && Boolean(labelContext?.tooltip);

  const Tag = as;
  return (
    <Tag
      className={`${styles.line} ${styles[`line${variant.charAt(0).toUpperCase()}${variant.slice(1)}`]} ${className}`.trim()}
      role="note"
      aria-label={ariaLabel}
      title={tooltip}
    >

      {showIcon && proof?.hasSocialProof ? (

        <FaUsers className={styles.icon} aria-hidden="true" />

      ) : null}

      <span className={styles.text}>{line}</span>

      {showInfoIcon ? (

        <FaInfoCircle className={styles.infoIcon} aria-hidden="true" />

      ) : null}

    </Tag>

  );

};



export default MatchFusedScoreLine;

